import { api } from '../../services/core/api';

export interface ImpersonationTargetProfile {
  id: string;
  displayName: string;
  email: string;
}

export interface StartImpersonationResponse {
  ticket: string;
  expiresAt: string;
  sessionId: string;
  target: ImpersonationTargetProfile;
}

export const impersonationService = {
  async start(userId: string): Promise<StartImpersonationResponse> {
    return api.post<StartImpersonationResponse>('/impersonation/start', { userId });
  },

  async stop(sessionId: string): Promise<void> {
    await api.post('/impersonation/stop', { sessionId });
  },
};
